export default {
  state: {
    viewPointContent: sessionStorage.getItem('viewpoint-snapshot') ? sessionStorage.getItem('viewpoint-snapshot') : '',
  },
  mutations: {
    SET_VIEWPOINT_CONTENT(state, viewPointContent) {
      state.viewPointContent = JSON.stringify(viewPointContent);
      sessionStorage.setItem('viewpoint-snapshot', JSON.stringify(viewPointContent));
    }
  },
  actions: {
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/viewpoint.js